import React, { useEffect, useState, useMemo } from "react";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CustomBadge from "../../../../common/components/CustomBadge";
import CustomTable, {
  HeadCell,
} from "../../../../common/components/CustomTable/CustomTable";
import { IAPIResponse, IBuyer } from "../../../../common/utils/interfaces";
import { formatDate } from "../../../../common/utils/helpers";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import { getBuyers } from "../../../../../apis/admin/buyers";

type Props = {
  setDetailData: (arg: IBuyer) => void;
};

const headCells: readonly HeadCell[] = [
  { id: "name", numeric: false, disablePadding: true, label: "Name" },
  { id: "email", numeric: false, disablePadding: true, label: "Email" },
  {
    id: "created",
    numeric: true,
    disablePadding: true,
    align: "center",
    label: "Date Joined",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
    align: "center",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
    align: "center",
  },
];

const BuyersTable: React.FC<Props> = ({ setDetailData }) => {
  const { layoutSearchText } = useSelector((state: RootState) => state.search);

  const [tableData, setTableData] = useState<IBuyer[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const tableTitle = { mainText: "Buyers", subText: "buyers" };

  useEffect(() => {
    fetchTableData();
  }, []);

  const fetchTableData = async () => {
    try {
      setLoading(true);
      const result: IAPIResponse | undefined = await getBuyers();
      if (result?.data) setTableData(result.data);
    } catch (err) {
      console.error("Error fetching buyers:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!layoutSearchText.trim()) return tableData;
    const search = layoutSearchText.toLowerCase();
    return tableData.filter(
      (buyer) =>
        buyer.first_name?.toLowerCase().includes(search) ||
        buyer.last_name?.toLowerCase().includes(search)
    );
  }, [layoutSearchText, tableData]);

  const selectData = (
    evt: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    selectedData: IBuyer
  ) => {
    evt.stopPropagation();
    setDetailData(selectedData);
  };

  const MappedTableRows = ({
    row,
    labelId,
    isItemSelected,
  }: {
    row: IBuyer;
    labelId: string;
    isItemSelected: boolean;
  }) => (
    <>
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>
      <TableCell component="th" id={labelId} scope="row" padding="none">
        {`${row.first_name} ${row.last_name}`}
      </TableCell>
      <TableCell padding="none">{row.email || "--"}</TableCell>
      <TableCell align="center">{formatDate(row.date_joined)}</TableCell>
      <TableCell align="center">
        <CustomBadge>{row.phone_number}</CustomBadge>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            gap: 1,
            cursor: "pointer",
          }}
          onClick={(evt) => selectData(evt, row)}
        >
          View details
        </Typography>
      </TableCell>
    </>
  );

  // Show loader while fetching
  if (loading) {
    return (
      <div className="w-full items-center justify-center">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "60vh",
          }}
        >
          <CircularProgress />
        </Box>
      </div>
    );
  }

  return (
    <CustomTable
      tableTitle={tableTitle}
      headCells={headCells}
      rows={filteredData}
      mappedTableRows={MappedTableRows}
    />
  );
};

export default BuyersTable;

// import React, { useEffect, useState, useMemo } from "react";
// import TableCell from "@mui/material/TableCell";
// import Typography from "@mui/material/Typography";
// import Checkbox from "@mui/material/Checkbox";
// import CustomBadge from "../../../../common/components/CustomBadge";
// import CustomTable, {
//   HeadCell,
// } from "../../../../common/components/CustomTable/CustomTable";
// import { IAPIResponse, IBuyer } from "../../../../common/utils/interfaces";
// import { formatDate } from "../../../../common/utils/helpers";
// import { useSelector } from "react-redux";
// import { RootState } from "../../../../../store/store";
// import { getBuyers } from "../../../../../apis/admin/buyers";

// type Props = {
//   setDetailData: (arg: IBuyer) => void;
// };

// const headCells: readonly HeadCell[] = [
//   { id: "name", numeric: false, disablePadding: true, label: "Name" },
//   { id: "email", numeric: false, disablePadding: true, label: "Email" },
//   { id: "created", numeric: true, disablePadding: true, label: "Date Joined" },
//   {
//     id: "phoneNumber",
//     numeric: false,
//     disablePadding: false,
//     label: "Phone Number",
//     align: "center",
//   },
//   {
//     id: "actions",
//     numeric: false,
//     disablePadding: false,
//     label: "Actions",
//     align: "center",
//   },
// ];

// const BuyersTable: React.FC<Props> = ({ setDetailData }) => {
//   const { layoutSearchText } = useSelector((state: RootState) => state.search);

//   const [tableData, setTableData] = useState<IBuyer[]>([]);

//   const tableTitle = { mainText: "Buyers", subText: "buyers" };

//   useEffect(() => {
//     fetchTableData();
//   }, []);

//   const fetchTableData = async () => {
//     const result: IAPIResponse | undefined = await getBuyers();
//     if (result?.data) {
//       setTableData(result.data);
//     }
//   };

//   const filteredData = useMemo(() => {
//     if (!layoutSearchText.trim()) return tableData;
//     const search = layoutSearchText.toLowerCase();
//     return tableData.filter(
//       (buyer) =>
//         buyer.first_name?.toLowerCase().includes(search) ||
//         buyer.last_name?.toLowerCase().includes(search)
//     );
//   }, [layoutSearchText, tableData]);

//   const selectData = (
//     evt: React.MouseEvent<HTMLSpanElement, MouseEvent>,
//     selectedData: IBuyer
//   ) => {
//     evt.stopPropagation();
//     setDetailData(selectedData);
//   };

//   const MappedTableRows = ({
//     row,
//     labelId,
//     isItemSelected,
//   }: {
//     row: IBuyer;
//     labelId: string;
//     isItemSelected: boolean;
//   }) => (
//     <>
//       <TableCell padding="checkbox">
//         <Checkbox
//           color="primary"
//           checked={isItemSelected}
//           inputProps={{ "aria-labelledby": labelId }}
//         />
//       </TableCell>
//       <TableCell component="th" id={labelId} scope="row" padding="none">
//         {`${row.first_name} ${row.last_name}`}
//       </TableCell>
//       <TableCell padding="none">{row.email || "--"}</TableCell>
//       <TableCell align="right">{formatDate(row.date_joined)}</TableCell>
//       <TableCell align="center">
//         <CustomBadge>{row.phone_number}</CustomBadge>
//       </TableCell>
//       <TableCell align="center">
//         <Typography
//           sx={{
//             alignItems: "center",
//             justifyContent: "center",
//             display: "flex",
//             gap: 1,
//             cursor: "pointer",
//           }}
//           onClick={(evt) => selectData(evt, row)}
//         >
//           View details
//         </Typography>
//       </TableCell>
//     </>
//   );

//   return (
//     <CustomTable
//       tableTitle={tableTitle}
//       headCells={headCells}
//       rows={filteredData}
//       mappedTableRows={MappedTableRows}
//     />
//   );
// };

// export default BuyersTable;
